module.exports = "https://www.gc-qa.gnp.com.mx/bb623ed1ef71aa3e31c8b870a3a419e4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/carruselgif-linea-gnp-portal.gif
// module id = 8075
// module chunks = 0